module.exports = __webpack_public_path__ + "static/img/6428_phase_function_Paper_PointsHejduk_Prediction.208e563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6428_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MF0X
// module chunks = 0